module.exports = __webpack_public_path__ + "static/img/application1.36653ecc.png";